import { filter, Observable } from 'rxjs';
import { QtFilterComponent } from '../components';
import { FilterOption } from '../models';
import { filter as filterDataSource } from '../utils';
import {
  PIPE_ORDER,
  QtDataSourceContext,
  QtDataTransformAdapter,
} from './qt-control-adapter';

export class FilterAdapter
  implements QtDataTransformAdapter<any, FilterOption[]>
{
  readonly key = 'psFilters';
  readonly pipeOrder = PIPE_ORDER.FILTER;

  private _suppress = false;
  private _ctx: QtDataSourceContext | null = null;

  readonly valueChanges$: Observable<FilterOption[]> =
    this.filterComponent.filterOptionsState$.pipe(
      filter(() => !this._suppress)
    );

  get operator() {
    return filterDataSource<any>(
      this.filterComponent.filter,
      this._ctx?.valueAccessorFn ?? (() => undefined)
    );
  }

  constructor(readonly filterComponent: QtFilterComponent) {}

  setContext(ctx: QtDataSourceContext): void {
    this._ctx = ctx;
  }

  applyValue(value: FilterOption[]): void {
    this._suppress = true;
    this.filterComponent.filterOptionsState$.next(value ?? []);
    this._suppress = false;
  }

  getValue(): FilterOption[] {
    return this.filterComponent.filterOptionsState$.getValue();
  }
}
